module.exports = __webpack_public_path__ + "assets/img/text-benefit-02.c448b174.svg";